import styled from "styled-components/macro";
import {
  EXPAND_COLUMN_WIDTH,
  SIDELIST_TITLE_BACKGROUND,
  SIDELIST_COLUMN_BACKGROUND,
  SELECT_GREEN,
  SETTINGS_BACKGROUND_COLOR,
  SETTINGS_TEXT_COLOR,
  VIEWPORT_TITLE_HEIGHT,
  SETTINGS_HEIGHT,
  BORDER_COLOR,
  SIDELIST_ROW_BORDER,
  SCROLLBAR_WIDTH,
  SCROLLBAR_COLOR,
  SCROLLBAR_BACKGROUND,
  SCROLLBAR_HOVERCOLOR,
  SCROLLBAR_BORDER,
} from "../../helpers/Const";
import { hexToRGB } from "../../helpers/StyleHelpers";

//scrollbar-color for Firefox
//webkit-scrollbar for Chrome
export const styledScrollBars = `
scrollbar-color: ${SCROLLBAR_COLOR} ${SCROLLBAR_BACKGROUND};
&::-webkit-scrollbar {
  width: ${SCROLLBAR_WIDTH}px;
  height: ${SCROLLBAR_WIDTH}px;
  background: ${SCROLLBAR_BACKGROUND};
}
&::-webkit-scrollbar-track {
  background: ${SCROLLBAR_BACKGROUND};
  border-radius: ${SCROLLBAR_WIDTH - 2 * SCROLLBAR_BORDER}px;
  border: ${SCROLLBAR_BORDER}px solid ${SCROLLBAR_BACKGROUND};
}
&::-webkit-scrollbar-thumb {
  background: ${SCROLLBAR_COLOR}; 
  border-radius: ${SCROLLBAR_WIDTH - 2 * SCROLLBAR_BORDER}px;
  border: ${SCROLLBAR_BORDER}px solid ${SCROLLBAR_BACKGROUND};
}
&::-webkit-scrollbar-thumb:hover {
  background: ${SCROLLBAR_HOVERCOLOR};
}
&::-webkit-scrollbar-corner {
  background: ${SCROLLBAR_BACKGROUND};
}`;

export interface ISideListRowOuterProps {
  height?: number;
}

export const SideListRowOuter = styled.div`
  position: relative;
  width: 100%;
  height: ${(props: ISideListRowOuterProps) => props.height}px;
  border-bottom: 1px solid ${SIDELIST_ROW_BORDER};
`;

export interface SideListRowStyledProps {
  checkedOutToSomeoneElse: boolean;
  bgColour: string;
  preventOutline: boolean;
  isSelected: boolean;
}

export const SideListRowStyled = styled.div`
  width: 100%;
  height: 100%;
  font-size: 12px;
  display: flex;
  align-items: center;
  cursor: ${(props: SideListRowStyledProps) => (props.checkedOutToSomeoneElse ? "default" : "grab")};
  background: ${(props: SideListRowStyledProps) => props.bgColour};
  &:active {
    cursor: ${(props: SideListRowStyledProps) => (props.checkedOutToSomeoneElse ? "default" : "grabbing")};
  }
  &:hover {
    ${(props: SideListRowStyledProps) =>
      !props.preventOutline && // eslint-disable-line indent
      `box-shadow: inset 0 0 0 2px ${SELECT_GREEN}; background: ${props.isSelected ? hexToRGB(SELECT_GREEN, 0.5) : props.bgColour};
    `}
  }
`;

export const SideListExpander = styled.div`
  height: 100%;
  flex: 0 0 ${EXPAND_COLUMN_WIDTH}px;
  justify-content: center;
  display: flex;
  max-height: 100%;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
  font-size: 24px;
`;

export interface ISideListContentItemProps {
  paddingLeft: number;
}

export const SideListContentItem = styled.div`
  padding-left: ${(props: ISideListContentItemProps) => (props.paddingLeft)}px;
  height: 100%;
  width: 100%;
  display: flex;
  align-content: center;
  align-items: center;
`;

export interface ISideListContentEditProps {
  hasError: boolean;
}

export const SideListContentEdit = styled.input`
  background: ${(props: ISideListContentEditProps) => (props.hasError ? "#ffc0c0" : "#ffffc0")};
  padding-left: 5px;
  height: 100%;
  width: 100%;
  border: none transparent;
  outline: none;
  font-size: 12px;
  font-family: Segoe UI;
`;

export const SideListContentText = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export interface ISideListContentWrapperProps {
  width?: number;
}

export const SideListContentWrapper = styled.div`
  width: ${(props: ISideListContentWrapperProps) => (props.width)}px;
  flex-basis: ${(props: ISideListContentWrapperProps) => (props.width)}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  height: 100%;
  flex: 0 0 auto;
  border-right: 1px solid ${BORDER_COLOR};
`;

export const TimelineRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TimelineContent = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  width: 100%;
`;

//height due to IE11
export const ViewPortTitleArea = styled.div`
  height: ${VIEWPORT_TITLE_HEIGHT}px;
  flex: 0 0 ${VIEWPORT_TITLE_HEIGHT}px;
  width: 100%;
  background: ${SIDELIST_TITLE_BACKGROUND};
  display: flex;
  align-items: center;
  color: white;
`;

export interface IViewPortContainerProps {
  height?: number;
}

export const ViewPortContainer = styled.div`
  height: ${(props: IViewPortContainerProps) => (props.height)}px;
  width: 100%;
  position: relative;
  ${styledScrollBars}
`;

export const ViewPortRoot = styled.div`
  flex: 1 1 auto;
  position: relative;
  overflow-y: scroll;
  overflow-x: scroll;
  display: flex;
  flex-direction: column;
  ${styledScrollBars}
`;

export interface IViewPortMainAreaProps {
  height?: number;
}

export const ViewPortMainArea = styled.div`
  height: ${(props: IViewPortMainAreaProps) => (props.height)}px;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export interface ITasksRootProps {
  width?: number;
  height?: number;
}

// left: 0 is for IE11
export const TasksRoot = styled.div`
  width: ${(props: ITasksRootProps) => (props.width)}px;
  height: ${(props: ITasksRootProps) => (props.height)}px;
  position: absolute;
  overflow: hidden;
  z-index: 2;
  left: 0;
`;


export const SideBarHeaderArea = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  background-color: ${SIDELIST_TITLE_BACKGROUND};
  text-align: center;
`;

export const SideBarTitle = styled.div`
  flex: 1 1 auto;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: ${EXPAND_COLUMN_WIDTH}px;
  font-size: 18px;
  text-transform: uppercase;
  text-align: left;
`;

/* Side Area */

export const SideBarRoot = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  background: ${SIDELIST_COLUMN_BACKGROUND};
`;

export interface ISideBarScrollContainerProps {
  width?: number;
}

export const SideBarScrollContainer = styled.div`
  width: ${(props: ISideBarScrollContainerProps) => (props.width)}px;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
  ${styledScrollBars}
`;

export interface ISideBarContentsProps {
  height?: number;
}

export const SideBarContents = styled.div`
  height: ${(props: ISideBarContentsProps) => (props.height)}px;
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
`;

export interface ISideBarContainerProps {
  width?: number;
}

export const SideBarContainer = styled.div`
  width: ${(props: ISideBarContainerProps) => (props.width)}px;
  position: relative;
  flex: 1 1 auto;
  height: 0px;
  overflow-x: hidden;
  overflow-y: scroll;
  ${styledScrollBars}
`;

/* Settings pane */

export const SettingsPanelStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  background: ${SETTINGS_BACKGROUND_COLOR};
  height: ${SETTINGS_HEIGHT}px;
  color: ${SETTINGS_TEXT_COLOR};
  position: relative;
`;

export interface ISettingsSubPanelStyledProps {
  width?: number;
}

export const SettingsSubPanelStyled = styled.div`
  ${(props: ISettingsSubPanelStyledProps) => (props.width ? `flex-basis: ${props.width}px;` : '')}
  flex-grow: ${(props: ISettingsSubPanelStyledProps) => (props.width ? 0 : 1)};
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
`;

export const SettingsVerticalPanelStyled = styled.div`
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
`;

export const SettingsPanelContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

export const SettingsPanelContainerColumn = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SettingsSpan = styled.span`
  flex: 1 0 auto;
  padding-left: 4px;
  padding-right: 4px;
`;

export const SettingsPanelSpan = styled.span`
  padding-bottom: 3px;
`;

export const ModalBackdrop = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: #55555555;
  top: 0;
  left: 0;
  z-index: 100;
`;

export interface IModalContainerProps {
  position: string;
}

export const ModalContainer = styled.div.attrs((props: IModalContainerProps) => ({
  style: {
    position: props.position ? props.position : "fixed",
  },
}))`
  z-index: 101;
  background: grey;
`;

export interface IFlexItemProps {
  marginLeft?: string;
  size?: number;
}

//IE11 requirement for wrapping buttons
export const FlexItem = styled.div.attrs((props: IFlexItemProps) => ({
  style: {
    marginLeft: props.marginLeft,
    width: props.size,
    height: props.size,
    flexBasis: props.size,
  },
}))`
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FlexItem22 = styled.div`
  width: 22px;
  height: 22px;
  flex-basis: 22px;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FlexItem50 = styled.div`
  width: 50px;
  height: 50px;
  flex-basis: 50px;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RightFlex = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
`;

export const VerticalFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const HorizontalFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 25px;
`;

export const Centered = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const ErrorElem = styled.div`
  color: red;
  flex: 1 1 auto;
  padding-left: 20px;
`;

export const UserMenuTrigger = styled.button`
  background: none!important;
  border: none;
  padding: 0!important;
  cursor: pointer;
`;

export const UserMenuContent = styled.div`
  background: white;
  position: absolute;
  border: 1px solid gray;
  top: 80px;
  right: 0;
  width: 240px;
  z-index: 25;
  padding-top: 10px;
  padding-left: 10px;
`;

export const UserMenuItem = styled.div`
  padding-bottom: 10px;
`;

export const UserMenuLink = styled.span`
  cursor: pointer;
`;